import { render, staticRenderFns } from "./ProductDetailComment.vue?vue&type=template&id=e8eacb62&scoped=true&"
import script from "./ProductDetailComment.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailComment.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetailComment.vue?vue&type=style&index=0&id=e8eacb62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8eacb62",
  null
  
)

export default component.exports